import { map } from 'rxjs/operators';
import type { ICard } from 'v2/components/Shared/SelectCreditCard';
import type { IShoppingSubscription, SubscriptionProductChangePlan } from 'v2/interfaces/shopping';

import apiService from '../api';
import type { ApiService } from '../api';

class ShoppingSubscriptionService {
  constructor(private apiService: ApiService) {}

  public getSubscription(subscriptionId: number) {
    return this.apiService
      .get(`/subscriptions/${subscriptionId}`)
      .pipe(map((response): IShoppingSubscription => response.data));
  }

  public loadSubscriptionHistory = (productId: number) => {
    return this.apiService.get(`/subscriptions/${productId}/invoices`, { is_customer: true });
  };

  public changeSubscriptionPayment(subscriptionId: number, card: ICard) {
    return this.apiService.post(`/subscriptions/${subscriptionId}/change_payment`, { payment_id: card.id });
  }

  public getChangePlanProducts(subscriptionId: number) {
    return this.apiService
      .get(`/subscriptions/${subscriptionId}/change_plan_products`)
      .pipe(map((response): SubscriptionProductChangePlan[] => response.data));
  }

  public changeSubscriptionPlan(subscriptionId: number, productId: number, installments: number) {
    return this.apiService.post(`/subscriptions/${subscriptionId}/change_plan`, {
      product_id: productId,
      installments
    });
  }
}

const shoppingSubscriptionService = new ShoppingSubscriptionService(apiService);
export default shoppingSubscriptionService;
